// Org status: active | suspended | archived.
// Tenant status: provisioning | trial | active | suspended | archived.
export function statusTone(status) {
    switch (status) {
        case 'active':
            return 'success';
        case 'trial':
        case 'provisioning':
            return 'primary';
        case 'suspended':
            return 'warning';
        case 'archived':
            return 'neutral';
        default:
            return 'neutral';
    }
}
